export default "__VITE_ASSET__BBZmMebf__"